import Page from '../../../shared/components/Page/Page';
import {Button, Form, Popconfirm, Space, Table, Tag, message} from "antd";
import {useContext, useEffect, useState} from "react";
import {formatDateTime, numberFormat} from "../../../shared/utils/helpers";
import TextCopy from "../../../shared/components/TextCopy";
import Search from "../../../shared/components/Search/Search";
import LoadingContext from "../../../app/contexts/LoadingContext";
import {
    DeleteOutlined,
    EditOutlined,
    PlusOutlined,
    ReloadOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import FormDrawer from "../../../shared/components/FormDrawer/FormDrawer";
import { getDeductionFees } from "../api";
import { createDeductionFee } from "../api";
import { updateDeductionFee } from "../api";
import { deleteDeductionFee } from "../api";
import { getChildPartners } from "../api";
import { getMainPartners } from "../api";
function DeductionFee() {
    const [, contextHolder] = message.useMessage();
    const [tableLoading, setTableLoading] = useState(false);
    const [form] = Form.useForm();
    const [formDrawer] = Form.useForm();
    const [dataSource, setDataSource] = useState([]);
    const {setLoading} = useContext(LoadingContext);
    const [openFormDrawer, setOpenFormDrawer] = useState(false);
    const [editingRecord, setEditingRecord] = useState(null);
    const [, setChildPartners] = useState([]);
    const [mainPartners, setMainPartners] = useState([]);
    const [summaryData, setSummaryData] = useState({
        totalDeductionAmount: 0,
    });
    const [tableParams, setTableParams] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
        search: {
            createdAt: [dayjs().startOf('day'), dayjs().endOf('day')]
        }
    });
    const items = [
        {
            name: 'userId',
            type: 'select',
            label: 'Đối tác',
            placeholder: 'Chọn đối tác',
            options: mainPartners.map((item) => ({
                value: item.userId,
                text: `${item.name} (${item.username})`
            })),
        },
        {
            name: 'createdAt',
            label: 'Ngày tạo',
            placeholder: 'Chọn khoảng thời gian',
            type: 'day'
        },
    ];
    const columns = [
        {
            title: 'ID',
            dataIndex: 'uuid',
            align: 'center',
            render: (value) => {
                return <TextCopy value={value}/>
            }
        },
        {
            title: 'Đối tác',
            dataIndex: 'username',
            align: 'center',
            render: (value) => {
                return <Tag color="blue">{value}</Tag>
            }
        },
        {
            title: 'Loại',
            dataIndex: 'type',
            align: 'center',
            render: (value) => {
                return <Tag color={value === 'in' ? 'green' : 'orange'}>
                    {value === 'in' ? 'Tiền vào' : 'Tiền ra'}
                </Tag>
            }
        },
        {
            title: 'Số tiền trừ',
            dataIndex: 'deductionAmount',
            align: 'center',
            sorter: true,
            render: (value) => {
                return <Tag color="red">{numberFormat(value)}</Tag>
            }
        },
        {
            title: 'Ngày trừ tiền',
            dataIndex: 'date',
            align: 'center',
            render: (value) => {
                return dayjs(value).format('DD/MM/YYYY')
            }
        },
        {
            title: 'Lý do',
            dataIndex: 'reason',
            align: 'center',
            render: (value) => {
                return <div style={{ maxWidth: '200px', wordWrap: 'break-word' }}>
                    {value}
                </div>
            }
        },
        {
            title: 'Người tạo',
            dataIndex: 'createdBy',
            align: 'center',
            render: (createdBy) => {
                return (
                    <div>
                        <Tag>{createdBy?.name}</Tag>
                    </div>
                )
            }
        },
        {
            title: 'Ngày tạo',
            dataIndex: 'createdAt',
            align: 'center',
            render: (value) => {
                return formatDateTime(value)
            }
        },
        {
            title: 'Thao tác',
            key: 'action',
            align: 'center',
            render: (_, record) => (
                <Space size="middle">
                    <Button
                        type="primary"
                        icon={<EditOutlined />}
                        size="small"
                        onClick={() => handleEdit(record)}
                    >
                        Sửa
                    </Button>
                    <Popconfirm
                        title="Xóa tiền trừ"
                        description="Bạn có chắc chắn muốn xóa tiền trừ này?"
                        onConfirm={() => handleDelete(record.deductionFeeId)}
                        okText="Có"
                        cancelText="Không"
                    >
                        <Button
                            type="primary"
                            danger
                            icon={<DeleteOutlined />}
                            size="small"
                        >
                            Xóa
                        </Button>
                    </Popconfirm>
                </Space>
            ),
        },
    ];
    const handleAdd = () => {
        setEditingRecord(null);
        formDrawer.resetFields();
        setOpenFormDrawer(true);
    };
    const handleEdit = (record) => {
        setEditingRecord(record);
        formDrawer.setFieldsValue({
            parentId: record.parentUser?.user_id || record.user?.parentUser?.user_id || record.user?.user_id,
            deductionAmount: record.deduction_amount,
            date: dayjs(record.date),
            reason: record.reason,
        });
        setOpenFormDrawer(true);
    };
    const handleDelete = async (deductionFeeId) => {
        setLoading(true);
        const response = await deleteDeductionFee( { deductionFeeId });
        if (response.success) {
            message.success('Xóa tiền trừ thành công');
            fetchDataDeductionFees();
        } else {
            message.error(response.message || 'Xóa tiền trừ thất bại');
        }
        setLoading(false);
    };
    const handleSubmitForm = async (values) => {
        setLoading(true);
        const params = {
            ...values,
            date: values.date.format('YYYY-MM-DD'),
        };
        let response;
        if (editingRecord) {
            response = await updateDeductionFee( {
                deductionFeeId: editingRecord.deductionFeeId,
                ...params,
                parentId: values.parentId
            });
        } else {
            response = await createDeductionFee( {
                ...params,
                parentId: values.parentId
            });
        }
        if (response.success) {
            message.success(editingRecord ? 'Cập nhật tiền trừ thành công' : 'Tạo tiền trừ thành công');
            setOpenFormDrawer(false);
            fetchDataDeductionFees();
        } else {
            message.error(response.message || 'Thao tác thất bại');
        }
        setLoading(false);
    };
    const handleSearch = () => {
        const params = form.getFieldsValue();
        setTableParams({
            ...tableParams,
            search: {
                ...params
            }
        })
    };
    const handleTableChange = (pagination, filters, sorter) => {
        setTableParams({
            ...tableParams,
            pagination,
            filters,
            sorter,
        });
    };
    const fetchDataDeductionFees = async () => {
        setTableLoading(true);
        const response = await getDeductionFees( tableParams);
        if (response.success) {
            setDataSource(response.data.data);
            setTableParams({
                ...tableParams,
                pagination: {
                    ...tableParams.pagination,
                    total: response.data.total
                },
            });
            setSummaryData({
                totalDeductionAmount: response.data.totalDeductionAmount,
            })
        }
        setTableLoading(false);
    };
    const fetchPartners = async () => {
        setLoading(true);
        const [childResponse, mainResponse] = await Promise.all([
            getChildPartners(),
            getMainPartners()
        ]);
        
        if (childResponse.success) {
            setChildPartners(childResponse.data);
        }
        if (mainResponse.success) {
            setMainPartners(mainResponse.data);
        }
        setLoading(false);
    };
    useEffect(() => {
        fetchDataDeductionFees();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        tableParams.pagination?.current,
        tableParams.pagination?.pageSize,
        tableParams?.sorter,
        tableParams?.search,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        JSON.stringify(tableParams.filters)
    ]);
    useEffect(() => {
        fetchPartners();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const formItems = [
        {
            name: 'userId',
            label: 'Đối tác',
            type: 'select',
            required: true,
            options: mainPartners.map(item => ({
                value: item.userId,
                label: `${item.name} (${item.username})`
            }))
        },
        {
            label: 'Loại tiền trừ',
            name: 'type',
            type: 'select',
            placeholder: 'Loại tiền trừ',
            options: [
                { value: 'in', text: 'Tiền vào' },
                { value: 'out', text: 'Tiền ra' }
            ],
        },
        {
            name: 'deductionAmount',
            label: 'Số tiền trừ',
            type: 'number',
            required: true,
            placeholder: 'Nhập số tiền trừ'
        },  
        {
            name: 'date',
            label: 'Ngày tiền trừ',
            type: 'date',
            required: true,
        },
        {
            name: 'reason',
            label: 'Lý do',
            type: 'textarea',
            required: true,
            placeholder: 'Nhập lý do tiền trừ'
        }
    ];
    return (
        <Page title="Tiền trừ đối tác">
            {contextHolder}
            
            {/* Statistics Cards */}
            <Space style={{ marginBottom: 16 }}>
                <Button 
                    type="primary" 
                    icon={<PlusOutlined/>} 
                    onClick={handleAdd}
                >
                    Thêm tiền trừ
                </Button>
                <Button 
                    icon={<ReloadOutlined/>} 
                    onClick={() => fetchDataDeductionFees()}
                >
                    Làm mới
                </Button>
            </Space>
            <Search
                items={items}
                form={form}
                onSearch={handleSearch}
            />
            <Table
                rowKey={'deductionFeeId'}
                columns={columns}
                scroll={{
                    x: 1500,
                }}
                bordered={true}
                loading={tableLoading}
                dataSource={dataSource}
                onChange={handleTableChange}
                pagination={tableParams.pagination}
                summary={(data) => {
                    return (
                        <Table.Summary.Row>
                            <Table.Summary.Cell index={0} colSpan={3}>
                                <strong>Thống kê</strong>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={1} align={'center'}>
                                <Tag color={'red'}>
                                    <strong>{numberFormat(summaryData.totalDeductionAmount)}</strong>
                                </Tag>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={2} colSpan={5} />
                        </Table.Summary.Row>
                    );
                }}
            />
            <FormDrawer
                title={editingRecord ? "Cập nhật tiền trừ" : "Thêm tiền trừ"}
                open={openFormDrawer}
                onClose={() => setOpenFormDrawer(false)}
                form={formDrawer}
                onSubmit={handleSubmitForm}
                items={formItems}
                width={600}
            />
        </Page>
    )
}
export default DeductionFee; 